import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { EmergencyRightsBar } from "@/components/EmergencyRightsBar";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AuthCallback } from "@/components/AuthCallback";

import Landing from "@/pages/Landing";
import Assistant from "@/pages/Assistant";
import Roadmap from "@/pages/Roadmap";
import Resources from "@/pages/Resources";
import Dashboard from "@/pages/Dashboard";
import Diagnostic from "@/pages/Diagnostic";
import Eligibility from "@/pages/Eligibility";
import Bail from "@/pages/Bail";
import Attorneys from "@/pages/Attorneys";
import AttorneyJoin from "@/pages/AttorneyJoin";
import Upgrade from "@/pages/Upgrade";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import AttorneyDashboard from "@/pages/AttorneyDashboard";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Disclosures from "@/pages/Disclosures";
import Guides from "@/pages/Guides";
import Charges from "@/pages/Charges";
import ChargeGuide from "@/pages/ChargeGuide";
import GuideState from "@/pages/GuideState";
import { RouteSeo } from "@/components/RouteSeo";
import Login from "@/pages/Login";
import Register from "@/pages/Register";

function Shell() {
  const location = useLocation();

  // Handle Google OAuth return synchronously during render.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <RouteSeo />
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/attorneys" element={<Attorneys />} />
          <Route path="/attorneys/join" element={<AttorneyJoin />} />
          <Route path="/upgrade" element={<ProtectedRoute><Upgrade /></ProtectedRoute>} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          <Route path="/attorney" element={<ProtectedRoute><AttorneyDashboard /></ProtectedRoute>} />
          <Route path="/assistant" element={<ProtectedRoute><Assistant /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/diagnostic" element={<ProtectedRoute><Diagnostic /></ProtectedRoute>} />
          <Route path="/eligibility" element={<Eligibility />} />
          <Route path="/bail" element={<Bail />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/guides/:slug" element={<GuideState />} />
          <Route path="/charges" element={<Charges />} />
          <Route path="/charges/:charge" element={<ChargeGuide />} />
          <Route path="/charges/:charge/:state" element={<ChargeGuide />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/disclosures" element={<Disclosures />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
        </Routes>
      </main>
      <Footer />
      <EmergencyRightsBar />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Shell />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
